import script from "./InfoPopoverBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoPopoverBtn.vue?vue&type=script&setup=true&lang=js"

import "./InfoPopoverBtn.vue?vue&type=style&index=0&id=45a2d2e3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a2d2e3"]])

export default __exports__